<div class="p-d-flex p-flex-row p-ai-center p-jc-between rating-bar" [class.small]="form === 'small'" #bar (click)="onClick($event)">

  <!-- 0 -->
  <ng-container *ngIf="rating === 0; else ratingBar">
    <ng-container *ngTemplateOutlet="starOff"></ng-container>
    <ng-container *ngTemplateOutlet="starOff"></ng-container>
    <ng-container *ngTemplateOutlet="starOff"></ng-container>
    <ng-container *ngTemplateOutlet="starOff"></ng-container>
    <ng-container *ngTemplateOutlet="starOff"></ng-container>
  </ng-container>

  <ng-template #ratingBar>

    <ng-container *ngIf="rating > 0 && rating <= 1">
      <ng-container *ngIf="rating < 1; else starOn">
        <ng-container *ngTemplateOutlet="halfStar"></ng-container>
      </ng-container>
      <ng-container *ngTemplateOutlet="starOff"></ng-container>
      <ng-container *ngTemplateOutlet="starOff"></ng-container>
      <ng-container *ngTemplateOutlet="starOff"></ng-container>
      <ng-container *ngTemplateOutlet="starOff"></ng-container>
    </ng-container>

    <ng-container *ngIf="rating > 1 && rating <= 2">
      <ng-container *ngTemplateOutlet="starOn"></ng-container>
      <ng-container *ngIf="rating < 2; else starOn">
        <ng-container *ngTemplateOutlet="halfStar"></ng-container>
      </ng-container>
      <ng-container *ngTemplateOutlet="starOff"></ng-container>
      <ng-container *ngTemplateOutlet="starOff"></ng-container>
      <ng-container *ngTemplateOutlet="starOff"></ng-container>
    </ng-container>

    <ng-container *ngIf="rating > 2 && rating <= 3">
      <ng-container *ngTemplateOutlet="starOn"></ng-container>
      <ng-container *ngTemplateOutlet="starOn"></ng-container>
      <ng-container *ngIf="rating < 3; else starOn">
        <ng-container *ngTemplateOutlet="halfStar"></ng-container>
      </ng-container>
      <ng-container *ngTemplateOutlet="starOff"></ng-container>
      <ng-container *ngTemplateOutlet="starOff"></ng-container>
    </ng-container>

    <ng-container *ngIf="rating > 3 && rating <= 4">
      <ng-container *ngTemplateOutlet="starOn"></ng-container>
      <ng-container *ngTemplateOutlet="starOn"></ng-container>
      <ng-container *ngTemplateOutlet="starOn"></ng-container>
      <ng-container *ngIf="rating < 4; else starOn">
        <ng-container *ngTemplateOutlet="halfStar"></ng-container>
      </ng-container>
      <ng-container *ngTemplateOutlet="starOff"></ng-container>
    </ng-container>

    <ng-container *ngIf="rating > 4 && rating <= 5">
      <ng-container *ngTemplateOutlet="starOn"></ng-container>
      <ng-container *ngTemplateOutlet="starOn"></ng-container>
      <ng-container *ngTemplateOutlet="starOn"></ng-container>
      <ng-container *ngTemplateOutlet="starOn"></ng-container>
      <ng-container *ngIf="rating < 5; else starOn">
        <ng-container *ngTemplateOutlet="halfStar"></ng-container>
      </ng-container>
    </ng-container>
  
  </ng-template>

</div>

<ng-template #starOn>
  <div class="star-on">
    <ng-container [ngSwitch]="type">
      <img *ngSwitchCase="'agent'" src="../../../../../../assets/images/rating-star-accent-on.svg" alt="star-on">
      <img *ngSwitchCase="'client'" src="../../../../../../assets/images/rating-star-client-on.svg" alt="star-on">
    </ng-container>
  </div>
</ng-template>

<ng-template #halfStar>
  <div class="half-star">
    <ng-container [ngSwitch]="type">
      <img *ngSwitchCase="'agent'" src="../../../../../../assets/images/rating-star-accent-half.svg" alt="half-star">
      <img *ngSwitchCase="'client'" src="../../../../../../assets/images/rating-star-client-half.svg" alt="half-star">
    </ng-container>
  </div>
</ng-template>

<ng-template #starOff>
  <div class="star-off">
    <ng-container [ngSwitch]="type">
      <img *ngSwitchCase="'agent'" src="../../../../../../assets/images/rating-star-accent-off.svg" alt="star-off">
      <img *ngSwitchCase="'client'" src="../../../../../../assets/images/rating-star-client-off.svg" alt="star-off">
    </ng-container>
  </div>
</ng-template>